import { INotesSuperTableColumnForPrintPreview } from './notes-super-table-column-for-print-preview.interface';
import { INotesSuperTableRowForPrintPreview } from './notes-super-table-row-for-print-preview.interface';
import { INotesSuperTableSegmentForPrintPreview } from './notes-super-table-segment-for-print-preview.interface';

export interface INotesSuperTableDataForPrintPreview {
    rows: INotesSuperTableRowForPrintPreview[];
    columns: INotesSuperTableColumnForPrintPreview[];
    segments: INotesSuperTableSegmentForPrintPreview[];
    transpose: boolean;
    componentTitle?: string;
    previousYear?: INotesSuperTableDataForPrintPreview;
    footnotes: string[];
    spacerColumns?: string[]; // Column IDs after which to insert spacers (for client-specific formatting)
    showSpacerBeforeCalculationRows?: boolean; // For Kendris (client), we add a spacer row before caclculation rows
}
